import React from 'react';
export function TransitionSection() {
  return <section className="py-20 px-4 bg-gradient-to-b from-[#FFF8F0] to-[#FEF3E2]" data-id="element-279">
      <div className="max-w-3xl mx-auto text-center" data-id="element-280">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 leading-tight text-[#3D2B1F]" data-id="element-281">
          Por eso creamos el{' '}
          <span className="text-[#D4850A]" data-id="element-282">
            Recetario Digital de Budines Caseros.
          </span>
        </h2>

        <p className="text-xl text-[#6B5344] mb-6" data-id="element-283">
          Una colección de recetas fáciles y probadas para que puedas preparar
          budines esponjosos, húmedos y deliciosos desde el primer intento.
        </p>

        <p className="text-xl text-[#6B5344] font-medium" data-id="element-284">
          Dentro del recetario vas a encontrar una selección de recetas de
          budines caseros fáciles de preparar, con{' '}
          <span className="text-[#3D2B1F] font-bold" data-id="element-285">
            instrucciones claras paso a paso.
          </span>
        </p>
      </div>
    </section>;
}